module.exports = __webpack_public_path__ + "img/ee.c237e0f4.svg";